import { render, staticRenderFns } from "./CheckoutDados.vue?vue&type=template&id=3a2484d4&scoped=true"
import script from "./CheckoutDados.vue?vue&type=script&lang=js"
export * from "./CheckoutDados.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDados.vue?vue&type=style&index=0&id=3a2484d4&prod&scoped=true&lang=css"
import style1 from "./CheckoutDados.vue?vue&type=style&index=1&id=3a2484d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2484d4",
  null
  
)

export default component.exports